import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { motion } from "framer-motion";
import axios from "axios";
import { useLang, useVisibleSections } from "@/content/ContentContext";
import { useT } from "@/content/i18n";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
let cvInfoRequest = null;

const useCvInfo = () => {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    if (!BACKEND) return undefined;
    let alive = true;
    cvInfoRequest = cvInfoRequest || axios.get(`${BACKEND}/api/cv/info`).then((r) => r.data).catch(() => null);
    cvInfoRequest.then((d) => { if (alive) setInfo(d); });
    return () => { alive = false; };
  }, []);
  return info;
};

export const CvDownload = ({ className = "chip", testId = "cv-download-button", compact = true }) => {
  const { lang } = useLang();
  const t = useT();
  const info = useCvInfo();
  if (!info?.fr && !info?.en) return null;
  const href = `${BACKEND}/api/cv.pdf?lang=${lang}`;
  return (
    <a href={href} download data-testid={testId} className={className} aria-label={t("cvPdf")} title={t("cvPdfTitle")}>
      <Download className="h-4 w-4" />
      <span className={compact ? "hidden sm:inline" : ""}>{t("cvPdf")}</span>
    </a>
  );
};

export const DiscoveryCounter = ({ visited }) => {
  const sections = useVisibleSections();
  const t = useT();
  const total = sections.length;
  const found = sections.filter((s) => visited.includes(s.id)).length;
  if (!total) return null;
  const done = found >= total;
  return (
    <motion.div
      data-testid="discovery-counter"
      className={`discovery ${done ? "is-done" : ""}`}
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.9 }}
      title={t("discoverHint")}
    >
      <span className="discovery-bar"><motion.span className="discovery-fill" animate={{ width: `${(found / total) * 100}%` }} transition={{ duration: 0.6 }} /></span>
      <span data-testid="discovery-counter-text">
        {done ? t("discoveredAll") : <><strong key={found} className="discovery-num">{found}/{total}</strong><span className="hidden sm:inline"> {t("discovered")}</span></>}
      </span>
    </motion.div>
  );
};
